import React from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { AvailabilityBusiness } from '@business/newCreateRequest/stepsItems/availability';
import { DatePicker, Utils } from 'oned';
import moment from 'moment';
import classnames from 'classnames';
import { AvailAbilityStep } from '@common/enums/availability';
var AvailabilityOptions = inject(AvailabilityBusiness)(observer(function (props) {
    var init = props.init, timeBlockList = props.timeBlockList, setAvailabilityTime = props.setAvailabilityTime, selectedAvailabilityTimes = props.selectedAvailabilityTimes, updateTimeBlockList = props.updateTimeBlockList, slaStartTime = props.slaStartTime, slaEndTime = props.slaEndTime, calendarDate = props.calendarDate, updateCalendarDate = props.updateCalendarDate, availabilityStep = props.availabilityStep, setAvailabilityParams = props.setAvailabilityParams, isStay = props.isStay, checkExpirationTime = props.checkExpirationTime, sameDayCheck = props.sameDayCheck;
    var onClickTimeBlock = function (timeBlock) {
        if (sameDayCheck(calendarDate)) {
            return false;
        }
        if (checkExpirationTime(timeBlock)) {
            window.notificationManager.show({
                title: "Warning!",
                type: "primary",
                position: "top-right",
                content: "Cannot select from the earlier date and time.",
            });
            return false;
        }
        var maxActiveLength = selectedAvailabilityTimes.filter(function (x) { return x.isActive; }).length;
        if (!calendarDate || maxActiveLength === 21) {
            return false;
        }
        if (checkActiveLength(maxActiveLength)) {
            return false;
        }
        if (timeBlock.active) {
            return false;
        }
        setAvailabilityTime(calendarDate, timeBlock.id);
    };
    var checkActiveLength = function (maxActiveLength) {
        if (isStay) {
            return false;
        }
        if (maxActiveLength === 7 && availabilityStep === AvailAbilityStep.FlexibleTime) {
            setAvailabilityParams('isSwitchToLimited', true);
            return true;
        }
        if (maxActiveLength === 7 && availabilityStep === AvailAbilityStep.LimitedTime) {
            setAvailabilityParams('isSwitchToFlexible', true);
            return true;
        }
        return false;
    };
    var updateDate = function (value) {
        updateCalendarDate(value);
        updateTimeBlockList(value);
    };
    var checkFlexibleSelectedDate = function (time) {
        if (selectedAvailabilityTimes.filter(function (x) { return !!x.isActive; }).length === 0) {
            return false;
        }
        return selectedAvailabilityTimes.filter(function (x) { return !!x.isActive; }).findIndex(function (i) {
            return moment(i.date).isSame(moment(time), 'day');
        }) !== -1 && availabilityStep === AvailAbilityStep.FlexibleTime;
    };
    var checkLimitedSelectedDate = function (time) {
        if (selectedAvailabilityTimes.filter(function (x) { return !!x.isActive; }).length === 0) {
            return false;
        }
        return selectedAvailabilityTimes.filter(function (x) { return !!x.isActive; }).findIndex(function (i) {
            return moment(i.date).isSame(moment(time), 'day');
        }) !== -1 && availabilityStep === AvailAbilityStep.LimitedTime;
    };
    return React.createElement("div", { className: 'pt-4' },
        React.createElement("div", { className: 'ft-18' },
            React.createElement("b", { className: 'title' }, "Availability options")),
        React.createElement("div", { className: 'mt-2' },
            React.createElement(DatePicker, { className: 'standard-version-canlendar', showYearMonthInput: true, time: calendarDate ? calendarDate : null, minDate: moment(moment(slaStartTime).format('YYYY/MM/DD')), maxDate: moment(moment(slaStartTime).add(21, 'days').format('YYYY/MM/DD')), slaStartTime: moment(slaStartTime), slaEndTime: moment(slaEndTime), onClear: function () { return updateCalendarDate(null); }, onConfirm: function (value) { return updateDate(value); }, dateRender: function (cur, val) {
                    if (((cur.month() === moment(slaStartTime).month() && cur.date() >= moment(slaStartTime).date()) ||
                        cur.month() > moment(slaStartTime).month()) &&
                        ((cur.month() === moment(slaEndTime).month() && cur.date() <= moment(slaEndTime).date()) ||
                            cur.month() < moment(slaEndTime).month())) {
                        return (React.createElement("div", { className: classnames("dsm-calendar-date highlight-date-frame", checkFlexibleSelectedDate(cur) && 'red-highlight', checkLimitedSelectedDate(cur) && 'green-highlight') }, cur.date()));
                    }
                    return React.createElement("div", { className: classnames("dsm-calendar-date", checkFlexibleSelectedDate(cur) && 'red-highlight', checkLimitedSelectedDate(cur) && 'green-highlight') }, cur.date());
                } },
                React.createElement("div", { className: "dsm-input-group icon icon-append" },
                    React.createElement("input", { value: Utils.formatDate(calendarDate), className: "dsm-form-control dsm-form-control", "data-one-uiautomation": "input.availablilityOptions.dateInput", type: "text" }),
                    React.createElement("div", { className: "dsm-input-group-append" },
                        React.createElement("i", { className: "ds-calendar-empty text-primary ds" })))),
            timeBlockList.map(function (block, index) { return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: classnames('dsm-card time-card cp', block.active && 'active'), onClick: function () { return onClickTimeBlock(block); } },
                    React.createElement("div", { className: 'dsm-card-body row no-gutters f14 time-block' },
                        React.createElement("div", { className: 'col-6' },
                            React.createElement("b", { className: 'time-quantum' }, block.id)),
                        React.createElement("div", { className: 'col-6' },
                            React.createElement("span", { className: 'specific-time' }, block.name)))),
                index === 0 && React.createElement("div", { className: 'block-divider' }))); })));
}));
export default AvailabilityOptions;
